// extracted by mini-css-extract-plugin
export default {"btn":"Keyboard_btn__VTVQR","active":"Keyboard_active__ghrL1","inactive":"Keyboard_inactive__JelJX"};